"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DataItem_1 = require("../common/base/DataItem");
var Field_1 = require("../../constants/Field");
var DataType_1 = require("../common/base/DataType");
var ConditionOut = /** @class */ (function () {
    function ConditionOut(name, subConditionNames) {
        this.init(name, subConditionNames);
        this.alarm = undefined;
    }
    ConditionOut.fromJson = function (conditionName, conditionJson) {
        var subCondition = conditionJson[Field_1.FIELD.SUBCONDITION];
        var subConditionNames = subCondition.enum;
        var conditionOut = new ConditionOut(conditionName, subConditionNames);
        return conditionOut;
    };
    ConditionOut.prototype.toJson = function () {
        var _a;
        var json = Object.create(null);
        var subCondition = this.subCondition.toJson(false);
        json[this.name] = (_a = {},
            _a[Field_1.FIELD.SUBCONDITION] = subCondition,
            _a[Field_1.FIELD.SEVERITY] = this.severity.toJson(false),
            _a[Field_1.FIELD.DESCRIPTION] = this.description.toJson(false),
            _a[Field_1.FIELD.POSSIBLECAUSE] = this.possibleCause.toJson(false),
            _a[Field_1.FIELD.SUGGESTEDACTION] = this.suggestedAction.toJson(false),
            _a[Field_1.FIELD.CORRECTIVEACTION] = this.correctiveAction.toJson(false),
            _a);
        if (this.alarm) {
            json[this.name] = Object.assign(json[this.name], this.alarm);
        }
        return json;
    };
    /**
     * Updates links of all condition fields to refer variables.functionName.outputs.conditions.field
     * @param functionName name of function of which this condition is part of
     */
    ConditionOut.prototype.referToVariables = function (functionName) {
        var linkBase = "#/variables/" + functionName + "/outputs/conditions/" + this.name + "/";
        this.subCondition.link = linkBase + Field_1.FIELD.SUBCONDITION;
        this.severity.link = linkBase + Field_1.FIELD.SEVERITY;
        this.description.link = linkBase + Field_1.FIELD.DESCRIPTION;
        this.possibleCause.link = linkBase + Field_1.FIELD.POSSIBLECAUSE;
        this.suggestedAction.link = linkBase + Field_1.FIELD.SUGGESTEDACTION;
        this.correctiveAction.link = linkBase + Field_1.FIELD.CORRECTIVEACTION;
    };
    ConditionOut.prototype.addAlarm = function (alarm) {
        this.alarm = alarm;
    };
    ConditionOut.prototype.toVariablesCondition = function () {
        if (!this.subCondition.enum) {
            throw new Error('Subcondition names can\'t be empty');
        }
        var conditionOut = new ConditionOut(this.name, this.subCondition.enum);
        return conditionOut;
    };
    ConditionOut.prototype.init = function (name, subConditionNames) {
        this.name = name;
        this.subCondition = new DataItem_1.DataItem(Field_1.FIELD.SUBCONDITION, DataType_1.DataType.string);
        this.subCondition.enum = subConditionNames;
        this.description = new DataItem_1.DataItem(Field_1.FIELD.DESCRIPTION, DataType_1.DataType.string);
        this.possibleCause = new DataItem_1.DataItem(Field_1.FIELD.POSSIBLECAUSE, DataType_1.DataType.string);
        this.suggestedAction = new DataItem_1.DataItem(Field_1.FIELD.SUGGESTEDACTION, DataType_1.DataType.string);
        this.correctiveAction = new DataItem_1.DataItem(Field_1.FIELD.CORRECTIVEACTION, DataType_1.DataType.string);
        this.severity = new DataItem_1.DataItem(Field_1.FIELD.SEVERITY, DataType_1.DataType.integer);
    };
    return ConditionOut;
}());
exports.ConditionOut = ConditionOut;
//# sourceMappingURL=ConditionOut.js.map